import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import {base, reports_card} from "../../api";
import {Link} from "react-router-dom";
import {Dialog} from "primereact/dialog";
import {Toast} from "primereact/toast";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {Button} from "primereact/button";
import ReportingProcessesAddForm from "./ReportingProcessesAddForm";
import ReportingProcessesEditForm from "./ReportingProcessesEditForm";
import {Tooltip} from "primereact/tooltip";

import ReportGeneration from "./components/ReportGeneration";

export default function ReportingProcesses() {
	const toast = useRef(null);
	const headers = {"Content-Type": "application/json"};
	const [reportings, setReportings] = useState([]);
	const [dialogVisible, setDialogVisible] = useState(false);
	const [editDialogVisible, setEditDialogVisible] = useState(false);
	const [newReporting, setNewReporting] = useState({name: "", icon: "pi-cog"});
	const [editReporting, setEditReporting] = useState(null);
	const [reportingDialogVisible, setReportingDialogVisible] = useState(false);

	useEffect(() => {
		fetchReportings();
	}, []);

	const fetchReportings = async () => {
		try {
			const response = await axios.get(base + reports_card);
			setReportings(Array.isArray(response.data) ? response.data : []);
		} catch (error) {
			console.error("Error fetching reportings:", error);
			setReportings([]); // Ensure it remains an array
		}
	};

	const handleAddReporting = () => {
		if (newReporting.name.trim()) {
			setReportings(prev => [...prev, {...newReporting, id: prev.length + 1}]);
			setDialogVisible(false);
			setNewReporting({name: "", icon: "pi-cog"});
			toast.current.show({
				severity: "success",
				summary: "Added",
				detail: "New reporting added",
				life: 3000,
			});
		}
	};

	const handleEditReporting = () => {
		setReportings(prev => prev.map(rep => (rep.id === editReporting.id ? editReporting : rep)));
		setEditDialogVisible(false);
		toast.current.show({
			severity: "success",
			summary: "Updated",
			detail: "Reporting updated",
			life: 3000,
		});
	};

	const remove = id => {
		axios
			.delete(`${base + reports_card}/${id}/`, {headers})
			.then(() => {
				fetchReportings();
				toast.current.show({
					severity: "success",
					summary: "Deleted",
					detail: "Reporting deleted successfully",
					life: 3000,
				});
			})
			.catch(error => {
				console.error("Error deleting reporting:", error);
				toast.current.show({
					severity: "error",
					summary: "Error",
					detail: "Failed to delete reporting",
					life: 3000,
				});
			});
	};

	const accept = id => {
		toast.current.show({
			severity: "success",
			summary: "Confirmed",
			detail: "You have accepted",
			life: 3000,
		});
		remove(id);
	};

	const reject = () => {
		toast.current.show({
			severity: "warn",
			summary: "Rejected",
			detail: "You have rejected",
			life: 3000,
		});
	};

	const confirmDelete = id => {
		confirmDialog({
			message: "Do you want to delete this record?",
			header: "Delete Confirmation",
			icon: "pi pi-info-circle",
			acceptClassName: "p-button-danger",
			accept: () => accept(id),
			reject,
		});
	};

	return (
		<div className="col-12 p-0 my-4">
			<Toast ref={toast} />
			<ConfirmDialog />
			<div className="card b-radius b-shadow border-0 p-3">
				<p className="d-flex align-items-center text-muted mb-0 text-uppercase">
					Փաստաթղթավորման բոլոր հաշվետվությունները
				</p>
				<hr />
				<div className="col-12">
					<div className="row">
						{reportings?.map((item, index) => (
							<div key={index} className="col-xl-3 col-lg-4 col-md-4 col-6 stretch-card p-3">
								<div className="card hover reportings b-shadow b-radius w-100 pt-3 pb-5 border-0 position-relative">
									<div
										type="button"
										onClick={() => {
											setEditReporting(item);
											setReportingDialogVisible(true);
										}}
										className="card-body justify-content-center text-center bg-transparent border-0 w-100">
										<div className="icon-holder b-shadow mt-3 mb-4">
											<i className={`pi ${item.icon} fs-3 p-3 text-${item.color}`}></i>
										</div>
										<span className="mb-0 text-uppercase">{item.name}</span>
									</div>
									<div className="position-absolute top-0 end-0 m-2 gap-2">
										<Button
											icon="pi pi-pencil"
											text
											rounded
											severity="secondary"
											className="p-0"
											onClick={() => {
												setEditReporting(item);
												setEditDialogVisible(true);
											}}
											data-pr-tooltip="Edit Reporting"
											data-pr-position="bottom"
										/>
										<Button
											icon="pi pi-trash"
											text
											rounded
											severity="secondary"
											className="p-0"
											onClick={() => confirmDelete(item.id)}
											data-pr-tooltip="Delete Reporting"
											data-pr-position="bottom"
										/>
										<Tooltip target=".p-button" />
									</div>
								</div>
							</div>
						))}
						<div className="col-xl-3 col-lg-4 col-md-4 col-6 stretch-card p-3">
							<div
								className="card hover b-shadow b-radius w-100 pt-3 pb-5 border-0"
								onClick={() => setDialogVisible(true)}>
								<div className="card-body justify-content-center text-center">
									<div className="icon-holder b-shadow mt-3 mb-4">
										<i className="pi pi-plus fs-3 p-3 text-success"></i>
									</div>
									<span className="mb-0 text-uppercase">նոր հաշվետվության բաժին</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Dialog
				visible={reportingDialogVisible}
				onHide={() => setReportingDialogVisible(false)}
				className="col-lg-6 col-11 mx-auto"
				header="Report Generation">
				<ReportGeneration item={editReporting} />
			</Dialog>
			<Dialog
				visible={dialogVisible}
				onHide={() => setDialogVisible(false)}
				className="col-lg-8 col-11 mx-auto"
				header="Ավելացնել նոր հաշվետվություն">
				<ReportingProcessesAddForm
					reporting={newReporting}
					setReporting={setNewReporting}
					onSave={handleAddReporting}
					setDialogVisible={setDialogVisible}
					dialogVisible={dialogVisible}
					fetchReportings={fetchReportings}
					toast={toast}
				/>
			</Dialog>
			<Dialog
				visible={editDialogVisible}
				className="col-lg-8 col-11 mx-auto"
				onHide={() => setEditDialogVisible(false)}
				header="Խմբագրել հաշվետվություն">
				<ReportingProcessesEditForm
					reporting={editReporting}
					setReporting={setEditReporting}
					editDialogVisible={editDialogVisible}
					setEditDialogVisible={setEditDialogVisible}
					onSave={handleEditReporting}
					fetchReportings={fetchReportings}
					toast={toast}
				/>
			</Dialog>
		</div>
	);
}
